import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { SasAvatarShape, SasAvatarSize, SasAvatarVariant } from '@interfaces';

@Component({
    selector: 'sas-avatar',
    standalone: true,
    template: `<ng-content></ng-content>`,
    styleUrl: './sas-avatar.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'sas-avatar',
        '[class.sas-avatar--green]':  'variant() === "green"',
        '[class.sas-avatar--purple]': 'variant() === "purple"',
        '[class.sas-avatar--amber]':  'variant() === "amber"',
        '[class.sas-avatar--sm]':     'size() === "sm"',
        '[class.sas-avatar--round]':  'shape() === "round"',
        '[style.background]':         'bgColor()',
        '[style.color]':              'textColor()',
        '[attr.role]':       'ariaLabel() ? "img" : null',
        '[attr.aria-label]':  'ariaLabel() || null'
    }
})
export class SasAvatarComponent {
    readonly variant   = input<SasAvatarVariant>('default');
    readonly size      = input<SasAvatarSize>('md');
    readonly shape     = input<SasAvatarShape>('square');
    readonly bgColor   = input<string>();
    readonly textColor = input<string>();
    readonly ariaLabel = input<string>();
}
